// Stub world contract — all write methods are no-ops that resolve immediately.
export function useWorldContract() {
  return {
    address: "0x0" as const,
    abi: [] as const,
    write: {
      addPlayer:        async (..._args: unknown[]) => "0xtx",
      addStory:         async (..._args: unknown[]) => "0xtx",
      universalSeed:    async (..._args: unknown[]) => "0xtx",
      addVote:          async (..._args: unknown[]) => "0xtx",
      incrementSecret:  async (..._args: unknown[]) => "0xtx",
    },
  };
}
